import resourceIcon from "@mui/icons-material/CardGiftcard";
import {
  Datagrid,
  DateField,
  List,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  TextInput,
} from "react-admin";
import { CardListActions } from "../../components";

const filters = [
  <TextInput source="email" alwaysOn />,
  <TextInput label="Date (Hebrew)" source="date_hebrew" alwaysOn />,
  <TextInput label="Dedication" source="name" alwaysOn />,
  <TextInput source="relationship" alwaysOn />,
];

function ListView(props) {
  return (
    <List
      {...props}
      actions={<CardListActions exporter={true} />}
      filters={filters}
      perPage={25}
      sort={{ field: "created_at", order: "DESC" }}
      title="Dedications"
    >
      <Datagrid rowClick="show">
        {/* <TextField source="date" /> */}
        <DateField source="created_at" label="Created" />
        <TextField
          source="date_hebrew"
          label="Date"
          style={{ minWidth: 120 }}
        />
        <TextField source="name" label="Dedication" />
        <TextField source="user_name" label="User" style={{ minWidth: 140 }} />
        <TextField source="email" />
        <TextField source="relationship" style={{ minWidth: 140 }} />
      </Datagrid>
    </List>
  );
}

function ShowView(props) {
  return (
    <Show {...props}>
      <TabbedShowLayout>
        <Tab label="Dedication">
          <TextField source="cause" />
          <DateField source="created_at" showTime label="Created" />
          <TextField source="date" label="Date Formatted" />
          <TextField source="date_hebrew" label="Hebrew Date" />
          <TextField source="name" label="Dedication" />
          <TextField source="user_name" label="User" />
          <TextField source="email" />
          <TextField source="relationship" />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
}

export const Dedications = {
  category: "database",
  name: "dedications",
  icon: resourceIcon,
  list: ListView,
  options: { label: "Dedications" },
  show: ShowView,
};
